import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import { Button, FormControl, FormControlLabel, FormLabel, Grid, ModalProps, Radio, RadioGroup } from '@mui/material';
import { useRouteLoaderData } from 'react-router-dom';

import {
  AppCampRoleFragment,
  CampQuery,
  Maybe,
  useCampRolesQuery,
  useCreateMissingCampRolesMutation,
  useUpdateCampMutation,
} from '../../../generated/graphql';
import { useModalRoute } from '../../../hooks';
import {
  BorderedBox,
  FlexColumn,
  PaddedModalView,
} from '../../common/CommonDivs';
import { CustomDialog } from '../../common/CustomDialog';
import {
  ButtonGroup,
  CloseButton,
  WhiteIconButton,
} from '../../icons/IconButton';
import { SingleRoleBox } from '../../item-card';
import { StyledModalHeader } from '../common/StyledModalHeader';


const MODAL_TITLE = 'Betalningar';

export const PaymentModal = observer(function PaymentModal(
  props: Omit<ModalProps, 'children'>,
) {

  const [ open, setOpen ] = useState('payments');
  const [ payment, setPayment ] = useState('no_payment');
  const [ codes, setCodes ] = useState([]);

  const camp = useRouteLoaderData('camp') as CampQuery['camp'];

   const [update] = useUpdateCampMutation();
  
  useEffect(() => {
    if (camp) {
      setPayment(camp.payment);


      const codes = JSON.parse(camp.payment_codes || '[]');
      setCodes(codes);

    }
  }, []);

 const handlePaymentMethodChange = (value) => {

  // Handle payment method change     
  console.log('Selected payment method:', value);

  setPayment(value);

  update({
    variables: {
      body: {
        camp_id: camp.camp_id,
        payment: value,
      },
    },
  });

 };


  return (
    <CustomDialog {...props} maxWidth={'md'}>
      <StyledModalHeader>
        <ButtonGroup></ButtonGroup>
        <h2>{MODAL_TITLE}</h2>
        <CloseButton
          onClick={(e) => {
            props.onClose(e, 'backdropClick');
          }}
        />
      </StyledModalHeader>
      <PaddedModalView>
 <Grid container spacing={3}>
          <Grid item xs={4}>
            <FlexColumn>
              <Button
                color="primary"
                variant="contained"
                size={'large'}
                style={{marginBottom: '20px'}}
                onClick={() => {
                  setOpen('payments');
                }}
              >
                Betalningsalternativ
              </Button>
              <Button
                color="primary"
                variant="contained"
                size={'large'}
                onClick={() => {
                  setOpen('codes');
                }}
              >
                Rabattkoder
              </Button>
            </FlexColumn>
          </Grid>

          <Grid item xs={8}>
                {open === 'payments' && (
                  <BorderedBox>
                    <h3>Välj sätt att betala</h3>
                    <p>Här kan du välja hur deltagarna ska betala.</p>    
                    <FormControl>
                      <RadioGroup
                        name="payment-buttons-group"
                      >
                        <FormControlLabel
                        checked={payment === 'no_payment'}
                          onClick={() => handlePaymentMethodChange('no_payment')}
                        value="no_payment" control={<Radio />} label="Ingen betalning vid anmälan" />
                        <FormControlLabel onClick={() => handlePaymentMethodChange('swish')}
                        checked={payment === 'swish'}
                         value="swish" control={<Radio />} label="Swish" />

                      </RadioGroup>
                    </FormControl>
                  </BorderedBox>
                )}
                {open === 'codes' && (
                  <BorderedBox>
                    <h3>Rabattkoder</h3>
                    <p>Här visas rabatter som du kan ge till deltagare.</p>

                  {codes && (
                    <>
                      {codes.map((code) => (                        
                        <div>Kod: {code.name} ({code.value}{code.type})</div>
                      ))}
                      
                      </>)
                      }
                  </BorderedBox>
                )}
          </Grid>
        </Grid>
      </PaddedModalView>
    </CustomDialog>
  );
});
